export const _7113 = 3 
export const tds = 0.1
export const estimateTds = 0
export const gst = 3
export const estimateGst = 0